// DS6.1.2
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useEffect, useState } from 'react';
import c from 'classnames';
import ListCard from '@wix/da-ds/pkg/List/ListCard';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { isDropdownGroup } from '../helpers';
import omit from 'lodash/omit';
import s from './MenuList.scss';
const MenuList = ({ id, items, itemsFillContainerWidth = false, className, ariaLabel, 'aria-describedby': ariaDescribedby, renderOnSSR = false })=>{
    const [mounted, setMounted] = useState(false);
    useEffect(()=>{
        setMounted(true);
    }, []);
    // Default is to render the menu on mount, set renderOnSSR
    const waitForMount = typeof window === 'undefined' && !mounted && renderOnSSR === false;
    if (waitForMount) {
        return null;
    }
    const renderListItem = (index, props)=>/*#__PURE__*/ React.createElement(ListItem, _object_spread_props(_object_spread({
            key: index
        }, omit(props, [
            'newTag'
        ])), {
            href: props.link || props.href,
            fillContainerWidth: itemsFillContainerWidth
        }));
    return /*#__PURE__*/ React.createElement(ListCard, {
        onClick: (e)=>e.stopPropagation(),
        id: id,
        className: c(s['root'], !itemsFillContainerWidth && s['content-width'], className),
        role: "dialog",
        "aria-describedby": ariaDescribedby,
        "aria-label": ariaLabel,
        tabIndex: 0
    }, items.map((item, index)=>{
        if (!item) {
            return null;
        }
        if (isDropdownGroup(item)) {
            return /*#__PURE__*/ React.createElement("div", {
                key: index,
                className: s['group']
            }, item.items.map((elm, idx)=>elm && renderListItem(idx, elm)));
        } else {
            const singleItem = item;
            return renderListItem(index, singleItem);
        }
    }));
};
MenuList.displayName = 'MenuList';
export default MenuList;
